import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/root/styles.scss';export default {
  "root": "_root_12jlg_1",
  "dragged": "_dragged_12jlg_6"
};